/**
 * @module
 */

import {FormController, location, reactive} from 'nova';
import {CHANGE, on} from '@acng/frontend-bounty/dom/event.js';
import {all} from '@acng/frontend-bounty/std/control.js';
import {guard, INTERFACE, IS_INPUT} from '@acng/frontend-rubicon';
import {UserProfileImageApi} from '../api/user-profile.js';
import {make} from '../core/service/env.js';
import {t} from '../locale/config/translate.js';

class UserImageWaiting {
  // DEBUG = true;
  @reactive accessor image = '';
  @reactive accessor inactive = true;
  @reactive accessor active = false;

  /**
   * @param {Awaited<ReturnType<UserProfileImageApi['get']>>} waitingImage
   */
  set(waitingImage) {
    this.image = waitingImage ? waitingImage.wide[900] : '';
    this.inactive = !waitingImage;
    this.active = !!waitingImage;
  }
}

class UserImageUpload extends FormController {
  waiting = new UserImageWaiting();
  placeholder = '';
  @reactive accessor filename = '';
  // @reactive accessor filesize = '';
  #api = make(UserProfileImageApi);

  /** @override */
  async compile() {
    const [placeholder, waiting] = await all([
      t('core.chooseFile'), //
      this.#api.get(),
    ]);

    this.placeholder = `${placeholder}...`;
    this.filename = this.placeholder;
    this.waiting.set(waiting);
  }

  /** @override @param {HTMLFormElement} form */
  upgrade(form) {
    ASSERT: guard(form.elements, INTERFACE({image: IS_INPUT}));
    const {image} = form.elements;

    image.required = true;
    image.type = 'file';
    image.accept = 'image/jpeg';

    on(image, CHANGE, () => {
      const file = image.files?.[0];

      this.filename = file ? file.name : this.placeholder;
      //this.filesize = file ? UserImageUpload.#returnFileSize(file.size) : '';
    });
  }

  /**
   * @param {HTMLFormElement} imageUploadForm
   * @param {FormData} dataWithImage
   *
   * @override
   */
  async submit(imageUploadForm, dataWithImage) {
    const tmpName = await this.#api.post(dataWithImage, imageUploadForm);
    location.href = `/profile/image/${tmpName}`;
  }

  /**
   * @param {number} number
   *
   * @returns {string}
   */
  static #returnFileSize(number) {
    if (number < 1e3) {
      return `${number} bytes`;
    } else if (number >= 1e3 && number < 1e6) {
      return `${(number / 1e3).toFixed(1)} KB`;
    }
    return `${(number / 1e6).toFixed(1)} MB`;
  }
}

export {UserImageUpload};
